import { merge } from 'lodash';

import contained from './contained';
import disabled from './disabled';
import loading from './loading';
import outlined from './outlined';
import root from './root';
import sizes from './sizes';
import text from './text';

const button = {
  defaultProps: {
    disableElevation: true,
    disableFocusRipple: true,
    disableRipple: true
  },
  styleOverrides: merge(
    { root: { ...root } },
    { fullWidth: { width: '100%' } },
    // Contained
    { ...contained },
    // Outlined
    { ...outlined },
    // Text
    { ...text },
    // Sizes Styling
    { ...sizes },
    // Disabled Styling
    { ...disabled },
    // Loading Styling
    { ...loading }
  )
};

export default button;
